import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Layers } from '@helpers/layers';
import { Device, from } from '@helpers/media';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled(m.div) `
  --xOffset: var(--sitePadding);
  --yOffset: 20dvh;

  position: fixed;
  z-index: ${Layers.ScrollArrow};
  bottom: var(--yOffset);
  right: var(--xOffset);

  @media ${from(Device.ActualDesktop)} {
    --xOffset: calc((100vw - var(--siteWidth) - 18px) / 2);
  }

  ${ButtonStyles.Container}[data-scroll] {
    --bgColour: ${brand.secondary.yellow.light};
    --bgColourActive: var(--bgColourHover);
    --bgColourDisabled: ${brand.grey.light};
    --bgColourHover: ${brand.secondary.yellow.dark};
    --borderColorActive: var(--bgColourActive);
    --borderColorHover: var(--bgColourHover);
    --borderColour: var(--bgColour);
    --borderColourDisabled: var(--bgColourDisabled);
    --buttonHeight: ${fluid(48, 80)};
    --colourText: ${brand.global.black};
    --colourTextDisabled: ${brand.grey.dark};
    --colourTextHover: var(--colourText);

    filter: drop-shadow(0px 0px 6px rgba(000, 000, 000, 0.4));

    ${ButtonStyles.IconWrapper} {
      transform: rotate(-90deg);
    }

    &:hover,
    &:focus-visible,
    &.focus-ring {
      ${ButtonStyles.IconWrapper} {
        transform: translateY(-4px) rotate(-90deg);
      }
    }
  }

  &[data-hidden='true'] {
    pointer-events: none;
  }

  &[data-scroll-direction='down'] {
    ${ButtonStyles.Container}[data-scroll] {
      ${ButtonStyles.IconWrapper} {
        transform: rotate(90deg);
      }

      &:hover,
      &:focus-visible,
      &.focus-ring {
        ${ButtonStyles.IconWrapper} {
          transform: translateY(4px) rotate(90deg);
        }
      }
    }
  }
`;
const ScrollArrowStyles = {
    Container,
};
export default ScrollArrowStyles;
